<mat-card-header [ngClass]="error ? 'system-message error' : ''">
  <mat-card-title>
    <h3>
      <ng-content></ng-content><span class="nsc-card-title__note mat-caption" *ngIf="note">{{ note }}</span></h3>
  </mat-card-title>
</mat-card-header>